var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"fluid"},[(_vm.$store.getters.isCompany)?[_c('FinancesForCompany')]:_vm._e(),(_vm.$store.getters.isTransportCompany)?[_c('FinancesForTransportCompany')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }